import { IADatabaseDocument } from "@/src/types/admissionDatabase";
import { getPdfPathBasename, normalizePdfPath } from "./normalizePdfPath";

const pathsMatch = (attachedFile: string, pdfPath: string): boolean => {
  const left = normalizePdfPath(attachedFile);
  const right = normalizePdfPath(pdfPath);
  if (!left || !right) return false;
  if (left === right) return true;

  const leftBase = getPdfPathBasename(attachedFile);
  const rightBase = getPdfPathBasename(pdfPath);
  return Boolean(leftBase && rightBase && leftBase === rightBase);
};

export const matchAuthDocByPdfPath = (
  docs: IADatabaseDocument[] | null | undefined,
  attachedFile: string,
): IADatabaseDocument | undefined => {
  if (!attachedFile?.trim() || !Array.isArray(docs) || docs.length === 0) return undefined;

  const exactMatch = docs.find((doc) => doc.pdf_path && pathsMatch(attachedFile, doc.pdf_path));
  if (exactMatch) return exactMatch;

  // If only one document returned for this fullname, use it as a pragmatic fallback.
  if (docs.length === 1 && docs[0]?.pdf_path) return docs[0];

  return undefined;
};
